// ** Reducers Imports
import layout from "./layout"
import navbar from "./navbar"
import lots from '@src/views/lots/store'
import auth from './authentication'
import globalconfig from "./globalconfig"
import employee from "@src/views/employees/store/"

const rootReducer = { navbar, auth, layout, globalconfig, lots, employee }

export default rootReducer
